import { render, staticRenderFns } from "./GiftcardFormAmountItem.vue?vue&type=template&id=52690c65&scoped=true&"
import script from "./GiftcardFormAmountItem.vue?vue&type=script&lang=js&"
export * from "./GiftcardFormAmountItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52690c65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52690c65')) {
      api.createRecord('52690c65', component.options)
    } else {
      api.reload('52690c65', component.options)
    }
    module.hot.accept("./GiftcardFormAmountItem.vue?vue&type=template&id=52690c65&scoped=true&", function () {
      api.rerender('52690c65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/GiftcardFormAmountItem.vue"
export default component.exports